import { Invocations } from "@/Actions/components";

import { useDatasetContext } from "../useDatasetContext";

/**
 * Renders the "Actions" tab of a dataset detail page: the shared
 * `<Invocations />` table scoped to the current dataset and the org
 * resolved by the dataset outlet.
 */
export function DatasetInvocations() {
  const { datasetId, org } = useDatasetContext();
  return <Invocations datasetId={datasetId} currentOrg={org} />;
}
